module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/load_error.ab6bd9e3.svg";